module.exports = __webpack_public_path__ + "static/media/memory-main.ca390106.png";